import React, { useEffect, useRef } from "react";
import { ParsedCountry, PhoneInput as ReactPhoneInput, PhoneInputProps as ReactPhoneInputProps, PhoneInputRefType } from "react-international-phone";
import styles from "./phone-input.module.scss";
import { africanCountries } from "../../../../common/utils/africanCountries";

export interface PhoneInputProps {
	value: string;
	onChange: (phone: string, dialCode?: string) => void;
	defaultCountry?: string;
	placeholder?: string;
	disabled?: boolean;
	error?: string;
	name?: string;
	required?: boolean;
	className?: string;
	// Locks the country and allows every African country (for prefilled numbers).
	lockCountry?: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
	value,
	onChange,
	defaultCountry = "ng",
	placeholder,
	disabled = false,
	error,
	name,
	required = false,
	className = "",
	lockCountry = false,
}) => {
	const phoneInputRef = useRef<PhoneInputRefType>(null);

	// defaultCountry is read only on mount; follow a later one (e.g. branding) while only the dial code is in.
	useEffect(() => {
		const input = phoneInputRef.current;
		if (!input || input.state.country.iso2 === defaultCountry) return;
		const digits = input.state.phone.replace(/\D/g, "");
		if (!digits || digits === input.state.country.dialCode) input.setCountry(defaultCountry);
	}, [defaultCountry]);

	const handleOnChange = (phone: string, meta: { country: ParsedCountry; inputValue: string }) => {
		onChange(phone, meta.country.dialCode);
	};
	return (
		<div className={`${styles.phoneInputWrapper} ${error ? styles.error : ""} ${className}`}>
			<ReactPhoneInput
				ref={phoneInputRef}
				defaultCountry={defaultCountry}
				value={value}
				countries={lockCountry ? africanCountries : undefined}
				hideDropdown={lockCountry}
				forceDialCode={lockCountry}
				onChange={handleOnChange}
				inputClassName={`${styles.phoneInput} ${error ? styles.error : ""}`}
				countrySelectorStyleProps={{
					buttonClassName: styles.countryButton,
					dropdownStyleProps: {
						className: styles.dropdown,
					},
				}}
				placeholder={placeholder}
				disabled={disabled}
				inputProps={{
					name,
					required,
				}}
			/>
			{error && <span className={styles.errorMessage}>{error}</span>}
		</div>
	);
};
